/**
 * DismissedRows.tsx — RULED 2026-10-21 (Klemen, on the R3 day-1 battery):
 * Home's Needs attention and My day follow the LATEST flag action. Rows whose
 * flags were all dismissed are held back behind one line, "{n} dismissed.
 * Show ›", and shown on request with the board's muted Dismissed capsule.
 *
 * P1: colors flow from src/theme/tokens.ts (canonical design system).
 */
import type { ReactNode } from 'react'
import { dismissedLine } from './homeView'

/** RULED 2026-10-21: the board's muted capsule (SalesPipeline's card) on a
 *  dismissed row that the viewer chose to show. */
export function DismissedCapsule() {
  return (
    <span className="k-badge-outline text-ink-muted uppercase shrink-0 self-center" data-dismissed="true"
      title="Every open flag behind this row is dismissed">
      <span className="k-badge-dot" />Dismissed
    </span>
  )
}

/** RULED 2026-10-21: "{n} dismissed. Show ›" — the rows a person dismissed,
 *  held back until asked for; "Hide ›" folds them away again. `list` picks
 *  the wrapper the rows need: div rows (Needs attention) or li items (My day). */
export function DismissedRows({ count, shown, onToggle, children, list = 'div' }: { count: number; shown: boolean; onToggle: () => void; children: ReactNode; list?: 'div' | 'ul' }) {
  return (
    <div className="flex flex-col gap-2">
      <p className="k-myday-quiet">
        {dismissedLine(count)}{' '}
        <button type="button" className="k-home-link" aria-expanded={shown} onClick={onToggle}>{shown ? 'Hide ›' : 'Show ›'}</button>
      </p>
      {shown && (list === 'ul'
        ? <ul aria-label="Dismissed" className="k-myday-list">{children}</ul>
        : <div role="list" aria-label="Dismissed" className="flex flex-col">{children}</div>)}
    </div>
  )
}
